let env = process.env.NODE_ENV
const host = env === 'development' ? 'http://localhost:3001/' : env === 'production' ? '' : 'http://localhost:8090/'
const assetsPath = process.env.ASSETSPATH
const root = env === 'development' ? '' : ''
const secretId = ''
const secretKey = ''
const catalogList = [{ 'title': '时政', 'id': '15702' }, { 'title': '财经', 'id': '15703' }, { 'title': '社会', 'id': '15704' }, { 'title': '国际', 'id': '15706' }, { 'title': '评论', 'id': '15707' }, { 'title': '科技', 'id': '15709' }, { 'title': '文化', 'id': '15708' }, { 'title': '体育', 'id': '15710' }]
const siteName = '育人号平台'
const ssoRoot = 'http://u.univs.cn/login?targetUrl=aHR0cCUzQS8vd3d3LnVuaXZzLmNuL3ptdC9mcm9udC9zZXNzaW9uU1NPL2xvZ2luJTNGcmVmZXJlciUzRGh0dHAlM0EvL3d3dy51bml2cy5jbi94eWgv'
let config = {
    env: env,
    // host: '/',
    host: host,
    assetsPath: assetsPath,
    // root: root,
    serverRoot: '/zmt/',
    secretId: secretId,
    secretKey: secretKey,
    catalogList: catalogList,
    siteName: siteName,
    ssoRoot: ssoRoot
}
export default config


// WEBPACK FOOTER //
// ./src/config/index.js